import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "f9dba9f4-6f7f-4a91-9d23-9c3f55c0fd00",
    content: "Normalisation of the transfer function for frontal sound incidence to a flat spectrum.",
    options: {},
  },
  {
    id: "e45b0591-5592-46ca-aada-8d9a421e73b0",
    content: "Normalisation of the transfer function for frontal sound incidence to the HRTF frontal incidence.",
    options: {},
  },
  {
    id: "808e49de-4cd2-4aac-b9c4-3d48718fd845",
    content: "Compensation of the influence of reproduction chain.",
    options: {},
  },
];

export const task: Task = {
  id: "e8fe9ce6-e9a5-4ffa-bf99-66413825d0b3",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["f9dba9f4-6f7f-4a91-9d23-9c3f55c0fd00", "808e49de-4cd2-4aac-b9c4-3d48718fd845"],
};
